import React from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiFetch } from "../lib/api";

export default function CalibrationAssets() {
  const { data, siteNames } = useHSE();
  const rows = data.calibrationAssets || data.calibration || [];

  const handleSaveRecord = async (editingRecord) => {
    try {
      const res = await apiFetch("/calibration-assets", {
        method: "POST",
        body: {
          ...editingRecord,
          idempotencyKey: `cal-${editingRecord.id}`,
        },
      });
      return res?.item ? { ...editingRecord, ...res.item } : editingRecord;
    } catch (err) {
      return editingRecord;
    }
  };

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      <StatCard label="Total Monitoring Assets" value={rows.length} testid="cal-total" />
      <StatCard label="In Service" value={rows.filter((r) => r.status === "in_service" || !r.status).length} tone="safe" />
      <StatCard label="Quarantined" value={rows.filter((r) => r.status === "quarantined" || r.isOutOfTolerance).length} tone="critical" />
      <StatCard label="Out of Service" value={rows.filter((r) => r.status === "out_of_service").length} tone="warning" />
      <StatCard label="Overdue" value={rows.filter((r) => r.nextDueDate && new Date(r.nextDueDate) < new Date()).length} tone="critical" />
    </div>
  );

  return (
    <RegisterPage
      title="Monitoring Assets & Calibration Governance"
      subtitle="Gas Detectors, Noise Meters, Lux Meters, Torque Wrench & Test Instrument Calibration Registers"
      storeKey="calibrationAssets"
      idPrefix="CAL"
      topPanels={Top}
      onSaveRecord={handleSaveRecord}
      columns={[
        { key: "id", label: "Asset ID" },
        { key: "assetNo", label: "Tag / Asset No" },
        { key: "equipmentType", label: "Instrument Type" },
        { key: "serialNumber", label: "Serial Number" },
        { key: "lastCalibrationDate", label: "Last Cal Date" },
        { key: "nextDueDate", label: "Next Due Date", render: (r) => <span className={`font-mono font-bold ${r.nextDueDate && new Date(r.nextDueDate) < new Date() ? "text-rose-600 font-extrabold" : "text-slate-700"}`}>{r.nextDueDate}</span> },
        { key: "approvedLabName", label: "Accredited Lab" },
        { key: "status", label: "Status", render: (r) => <span className={`uppercase text-[10px] font-bold px-2 py-0.5 rounded ${r.status === "quarantined" || r.isOutOfTolerance ? "bg-rose-100 text-rose-800" : r.status === "out_of_service" ? "bg-amber-100 text-amber-800" : "bg-emerald-100 text-emerald-800"}`}>{r.status || "in_service"}</span> },
        { key: "actionId", label: "Linked CAPA", render: (r) => r.actionId ? <span className="font-mono text-[11px] text-[#18B84F]">{r.actionId}</span> : <span className="text-slate-300">—</span> },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "Asset ID" },
        { key: "assetNo", label: "Asset Tag Number" },
        { key: "serialNumber", label: "Manufacturer Serial Number" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "equipmentType", label: "Instrument Type", type: "select", options: ["4-Gas Detector (LEL/O2/CO/H2S)", "Sound Level Meter Class 1", "Lux Meter", "Multi-Meter", "Torque Wrench", "Radiation Monitor"] },
        { key: "ownerUserId", label: "Responsible Owner User ID" },
        { key: "calibrationIntervalMonths", label: "Calibration Interval (Months)", type: "number" },
        { key: "lastCalibrationDate", label: "Last Calibration Date", type: "date" },
        { key: "nextDueDate", label: "Next Due Date", type: "date" },
        { key: "approvedLabName", label: "Accredited Calibration Lab Name" },
        { key: "certificateRef", label: "Certificate External Ref" },
        { key: "isOutOfTolerance", label: "Out of Tolerance Condition?", type: "select", options: [false, true] },
        { key: "status", label: "Status", type: "select", options: ["in_service", "out_of_service", "quarantined", "retired"] },
      ]}
    />
  );
}
